import { render, staticRenderFns } from "./ProfileTalentAvailabilityChildOpportunityItem.vue?vue&type=template&id=46f6db9e&scoped=true"
import script from "./ProfileTalentAvailabilityChildOpportunityItem.vue?vue&type=script&lang=js"
export * from "./ProfileTalentAvailabilityChildOpportunityItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f6db9e",
  null
  
)

export default component.exports